import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import {store} from 'Store';
import { useState, useEffect,useReducer } from "react";
import { useSelector, useDispatch } from "react-redux";
import {useParams, useLocation, useNavigate } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import DatatableDropdownEntryField from "Components/Datatable/DatatableComponents/DatatableDropdownEntryField";
import DatatableDropdownCheckboxesField from "Components/Datatable/DatatableComponents/DatatableDropdownCheckboxesField";
import { FilterDrama } from "@mui/icons-material";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import Download from '@mui/icons-material/FileDownloadOutlined';
import { ICONS } from "Utils/icons";




const UserActivityTable = ({ ...props}) => {
    // Date format: mm/dd/yyyy hh: mm
    const loginInfo = useSelector(state => state.loginInfo);
    //console.log(loginInfo);

    let location = useLocation();
    
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
  

    const [sortColumn, setSortColumn] = useState({
        sortField: "lastLoginDate",
        sortDirection: "desc"
    });

    const [filter, setFilter] = useState(null);
    const [docFilter, setDocFilter] = useState(null);
  
    useEffect(()=>{
        var passedData = location.state;
        
        if(isInObject("filter",passedData)) {
            //console.log("setFilter");
            //console.log(passedData.filter);
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex:0,
                entryPerPage:10,
                sortingColumn:sortColumn.sortField,
                sortingOrder:sortColumn.sortDirection,
                searchTerm:""
            });
        }
        //console.log(filter);
        //console.log(docFilter);
    },[])



    const getTest = async (filter) => {   
        var call = filter;
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/dashboard/getUserActivity';
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }


    


    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        

        listColumns.push(Datatable_Column({
            name:"PSO ID", 
            columnName:"psoId", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"User Name", 
            columnName: ['firstName', 'lastName'],
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"User Email", 
            columnName:"emailAddress", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"User Role", 
            columnName:"roleName", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo
        }))
        listColumns.push(Datatable_Column({
            name:"Last Login Date", 
            columnName:"lastLoginDate", 
            selectedRows: selectedList, 
            sortable:true, 
            sortingInfo:sortingInfo,
            formatFunction: formatDate
        }))
        
        return listColumns;
      }

      const tableTitle = function () {
        return "User Activity";
      }
      
      const tableDescription = function() {
        return "The User Activity table displays data for the last 60 days.";
      }
      const [selectedCount, setSelectedCount] = useState(0);


    

  return (
    <>
       
        { filter!=null ?
            <DatatableBase 

                tableClassName="userActivityDashTable" 
                getData={getTest} 
                uniqueId="userActivityDashTable"
                
                filter = {filter}
                setFilter={setFilter}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={"Search by PSO ID, First Name, Email or User Role"} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
            >
                    
               
            
            </DatatableBase>
            :null
        }  
    </>
  );
}

export default UserActivityTable;